import axios from "axios";




const c_values = {
  c_REMOTE_URL: (process.env.VUE_APP_BASE_URL_SERVER || "http://localhost:8951" ) + '/',
  async cargarConfig() {
    const result = await axios.get("/config.json");

    this.c_REMOTE_URL = result.data.c_REMOTE_URL;
  }
};

export default c_values;
